import { render, staticRenderFns } from "./RatgeberApp.vue?vue&type=template&id=23ecb01a&"
import script from "./RatgeberApp.vue?vue&type=script&lang=js&"
export * from "./RatgeberApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports